const business = {
  namespaced: true,
  state: {
    niche: '',
    industryServed: '',
    customerCount: '',
    haveWebsite: true,
    websiteUrl: '',
    tools: [],
    password: '',
    address: '',
    addressLine: '',
    country: 'US',
    region: '',
    city: '',
    zipcode: '',
    tandc: false,
    snapshotId: '',
    isReselling: undefined,
    planId: '',
    affiliateSignup: false,
    agencyPrimaryUseRaw: '',
    agencyPrimaryUse: '',
    showNicheOptions: false
  } as any,
  actions: {
    set({ commit }, payload: any) {
      commit('set', payload)
    }
  },
  mutations: {
    updateInfo(
      state: any,
      {
        industryServed,
        niche,
        customerCount,
        haveWebsite,
        websiteUrl,
        agencyPrimaryUseRaw,
        agencyPrimaryUse
      }: any
    ) {
      state.industryServed = industryServed
      state.niche = niche
      state.customerCount = customerCount
      state.haveWebsite = haveWebsite
      state.websiteUrl = websiteUrl
      state.agencyPrimaryUseRaw = agencyPrimaryUseRaw
      state.agencyPrimaryUse = agencyPrimaryUse
    },
    updateTools(state: any, tools: []) {
      state.tools = tools
    },
    updatePassword(state: any, password: string) {
      state.password = password
    },
    updateAddress(state: any, payload: any) {
      state.address = payload.address
      state.addressLine = payload.addressLine
      state.country = payload.country
      state.region = payload.region
      state.city = payload.city
      state.zipcode = payload.zipcode
      state.isReselling = payload.isReselling
      state.tandc = payload.termsnCondition
    },
    set(state: any, payload: any) {
      for (const key in payload) {
        state[key] = payload[key]
      }
    },
    updateGaData(state: any, payload: any) {
      state.planId = payload.planId
      state.industryServed = payload.industryServed
      state.niche = payload.niche || ''
      state.customerCount = payload.customerCount
      state.haveWebsite = payload.haveWebsite
      state.websiteUrl = payload.websiteUrl
      state.tools = payload.tools || []
      state.isReselling = payload.reselling
      state.country = payload.country ? payload.country : 'US'
      state.region = payload.region
      state.affiliateSignup = payload.affiliateSignup
        ? payload.affiliateSignup
        : false
    }
  }
}

export default business
